module.exports = __webpack_public_path__ + "media/images/pic/hero/clouds-f25bab4bbdf2c74d82320d0c69035c3d.webp";